import React, { useEffect, useRef, useState } from 'react'
import { debounce } from 'libraries/lodash'
import cx from 'classnames'
import { scrollTo } from 'front-end-core/helpers/document'
import Comments from 'pages/comments/ConnectedComments'
import { CommentsSkeleton } from 'pages/dashboard/Skeleton'
import FiltersContainer from 'redux/containers/pages/comments/FiltersContainer'
import FlavourSelector from './FlavourSelector'

const Annotations = ({
  handleClick,
  selected,
  order,
  users,
  privacy,
  archived,
  preview,
  pageLength,
  page,
  encryptionKeysLoaded,
  isFiltered,
  isAnnotationsLoaded,
  pageId,
  isMobile,
  flavour
}) => {
  const scrollToRef = useRef()
  const [showPlaceholder, setShowPlaceholder] = useState(true)

  useEffect(() => {
    scrollTo({ pageId, element: scrollToRef.current, animate: true, useWindowScrollTo: isMobile })
  }, [page, scrollToRef])

  useEffect(() => {
    const debounceThis = debounce(() => {
      if (encryptionKeysLoaded && isFiltered && isAnnotationsLoaded) {
        setShowPlaceholder(false)
      }
    }, 100)
    debounceThis()
  }, [encryptionKeysLoaded, isFiltered, isAnnotationsLoaded])

  return (
    <div
      className='layout-width-constraint bg-white'
      onClick={handleClick}
      ref={scrollToRef}
    >
      <section className='flex justify-center pv6 mb2 flavour-tabs relative'>
        <FlavourSelector {...{
          selected,
          order,
          users,
          privacy,
          archived,
          preview
        }}
        />
      </section>
      <FiltersContainer {...{ selected, order, users, privacy, archived, preview }} />
      {showPlaceholder && <CommentsSkeleton />}
      {encryptionKeysLoaded && (
        <div className={cx({ dn: !isAnnotationsLoaded })}>
          <Comments
            {...{
              flavour,
              pageLength,
              category: selected,
              order,
              users,
              privacy,
              archived,
              page: parseInt(page),
              preview
            }}
          />
        </div>
      )}
    </div>
  )
}

export default Annotations
